"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _H = _interopRequireDefault(require("../elements/headings/H2"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _UIIllustration = _interopRequireDefault(require("../image/UIIllustration"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _illustrationName = require("../utils/propTypes/illustrationName");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _Style = require("../core/Style");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MessageOuter = (0, _styledComponents.default)(_UISection.default).withConfig({
  displayName: "UIResultsMessage__MessageOuter",
  componentId: "sc-1wlytx0-0"
})(_templateObject());

var MessageBody = _styledComponents.default.div.withConfig({
  displayName: "UIResultsMessage__MessageBody",
  componentId: "sc-1wlytx0-1"
})(_templateObject2());

var MessageImage = (0, _styledComponents.default)(_UIIllustration.default).withConfig({
  displayName: "UIResultsMessage__MessageImage",
  componentId: "sc-1wlytx0-2"
})(_templateObject3(), (0, _Style.remCalc)(40));
var defaultIllustrationProps = {
  width: 175
};

var renderTitle = function renderTitle(title) {
  if (!title) return null;
  if (_react.default.isValidElement(title)) return title;
  return _react.default.createElement(_H.default, null, (0, _lazyEval.default)(title));
};

var renderImage = function renderImage(illustration, illustrationProps, Image) {
  if (!illustration && !Image) return null;
  return _react.default.createElement(Image, (0, _extends2.default)({
    name: illustration
  }, defaultIllustrationProps, illustrationProps));
};

var _default = _react.default.createClass({
  displayName: "UIResultsMessage",
  propTypes: {
    Body: _component.default,
    children: _propTypes.default.node,
    illustration: (0, _illustrationName.getIllustrationNamePropType)(),
    illustrationProps: _propTypes.default.object,
    Image: RenderProp.getPropType(_UIIllustration.default),
    title: (0, _createLazyPropType.default)(_propTypes.default.node)
  },
  getDefaultProps: function getDefaultProps() {
    return {
      Body: MessageBody,
      Image: MessageImage,
      illustrationProps: defaultIllustrationProps
    };
  },
  render: function render() {
    var _this$props = this.props,
        Body = _this$props.Body,
        children = _this$props.children,
        className = _this$props.className,
        illustration = _this$props.illustration,
        illustrationProps = _this$props.illustrationProps,
        Image = _this$props.Image,
        title = _this$props.title,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["Body", "children", "className", "illustration", "illustrationProps", "Image", "title"]);
    return _react.default.createElement(MessageOuter, (0, _extends2.default)({}, rest, {
      className: className,
      role: "alert",
      use: "island"
    }), renderImage(illustration, illustrationProps, Image), renderTitle(title), _react.default.createElement(Body, null, children));
  }
});

exports.default = _default;
module.exports = exports.default;